import React from 'react';

import Config from '../../shared/config/Configuration';
import Section from '../section/Section';


const AppContent = (props) => {
  return (
    <React.Fragment>
      {Config.sections.map((section) =>
        <Section key={section.id} bgImage={section.bgImage} title={section.title} id={section.id}>
          {section.component && <section.component/>}
        </Section>
      )}
    </React.Fragment>
  );
}

export default AppContent;
